export const FETCH_BANK_ACCOUNTS = "FETCH_BANK_ACCOUNTS";
